import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const HeaderWrapper = styled.div`
    width: 100%;
    justify-content: space-between;
    flex-wrap: nowrap;
    margin-top: 86px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        margin-top: 75px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin-top: 66px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        margin-top: 63px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: column-reverse;
        margin-top: 65px;
        margin-bottom: 43px;
    }
`;

export const HeaderContent = styled.div`
    flex-direction: column;
    max-width: 560px;
    margin-top: 29px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        margin-top: 40px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        max-width: 446px;
        margin-top: 0;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        max-width: 334px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        max-width: unset;
    }
`;

export const HeaderPreTitle = styled.h1`
    ${FONTS.H5};
`;

export const HeaderTitle = styled.div`
    ${FONTS.H1};
    margin-top: 0;
    margin-bottom: 8px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        ${FONTS.H2}
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.H3}
    }
`;

export const HeaderSubTitle = styled.div`
    ${FONTS.M};
    margin-bottom: 16px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        ${FONTS.S}
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.XS}
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.S}
    }
`;

export const SBaseButton = styled(BaseButton)`
    max-width: max-content;

    @media (max-width: ${wideBreakpoints.mobile}) {
        max-width: unset;
    }
`;

export const HeaderMedia = styled.div`
    max-width: 590px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        max-width: 454px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        max-width: 353px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        max-width: unset;
    }
`;

export const HeaderImage = styled(LazyLoadImage)`
    width: 100%;
    height: auto;
    border-radius: ${BorderRadius.OuterBlockRadius};
`;
